exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vti__flag{margin-right:8px}.vue-tel-input-vuetify{display:flex;align-items:center}.vue-tel-input-vuetify .country-code{width:75px}.vue-tel-input-vuetify li.last-preferred{border-bottom:1px solid #cacaca}.vue-tel-input-vuetify .v-text-field .v-select__selections{position:relative}.vue-tel-input-vuetify .v-text-field .v-select__selections .vti__flag{position:absolute;margin-left:18px}.vue-tel-input-vuetify .v-text-field--outlined .v-select__selections .vti__flag{margin-left:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-257079dd","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/PhoneInput.vue
// module id = 864
// module chunks = 0